import { CircularProgress } from '@material-ui/core';
import React from 'react';
import { StyledButton, StyledLink } from './style';

export const CommonButton = ({ label, action, color, variant, disabled, fontColor, fontSize, loading = false }) => {
  return (
    <StyledButton
      fontSize={fontSize}
      fontcolor={fontColor}
      disabled={disabled ? disabled : false}
      variant={variant ? variant : 'contained'}
      onClick={() => action()}
      btncolor={color}
    >
      {loading ? <CircularProgress color="secondary" /> : label ? label : 'Salvar'}
    </StyledButton>
  );
};

export const CommonLink = ({ to, color, children }) => {
  return (
    <StyledLink to={to} color={color}>
      {children}
    </StyledLink>
  );
};
